import { ChakraProvider } from '@chakra-ui/react';
import { nmdTheme } from './theme';

export const withChakraUi = (component: () => React.ReactNode) => () =>
  <ChakraProvider theme={nmdTheme}>{component()}</ChakraProvider>;
